import { useEffect, useState } from 'react'
import api from '../services/api'
import LookupSelect from '../components/LookupSelect'
import ItemSelect from '../components/ItemSelect'

// Cadastro de Combustíveis (GeneXus TCOMBUS → frota.combus), em Combustível → Parâmetros.
interface Combustivel {
  comcod: string; comest: number; comdes: number; comdep: string; comapli: string
  comdta: string | null; comdmo: string | null
  item_des: string | null; despesa_des: string | null; dep_des: string | null; apl_des: string | null
}
const NOVO: Combustivel = { comcod: '', comest: 0, comdes: 0, comdep: '', comapli: '', comdta: null, comdmo: null, item_des: null, despesa_des: null, dep_des: null, apl_des: null }

function Campo({ label, width, children }: { label: string; width?: number | string; children: React.ReactNode }) {
  return (
    <div className="field-cad" style={{ width }}>
      <label style={{ display: 'block', minHeight: '1.1rem', lineHeight: 1.2 }}>{label}</label>
      {children}
    </div>
  )
}

export default function CadastroCombustiveis() {
  const [lista, setLista] = useState<Combustivel[]>([])
  const [busca, setBusca] = useState('')
  const [carregando, setCarregando] = useState(false)
  const [selecionado, setSelecionado] = useState<string | null>(null) // '' = novo
  const [form, setForm] = useState<Combustivel | null>(null)
  const [tiposDespesa, setTiposDespesa] = useState<{ cod: number; des: string }[]>([])
  const [salvando, setSalvando] = useState(false)
  const [msg, setMsg] = useState<{ texto: string; ok: boolean } | null>(null)

  async function carregarLista(termo: string) {
    setCarregando(true)
    try { setLista((await api.get('/combustivel-cadastro', { params: termo ? { busca: termo } : {} })).data) }
    finally { setCarregando(false) }
  }
  useEffect(() => { api.get('/combustivel-cadastro/tipos-despesa').then(r => setTiposDespesa(r.data)).catch(() => {}) }, [])
  useEffect(() => { const t = setTimeout(() => carregarLista(busca), 300); return () => clearTimeout(t) }, [busca])

  async function selecionar(cod: string) {
    setMsg(null)
    const r = await api.get(`/combustivel-cadastro/${encodeURIComponent(cod)}`)
    setSelecionado(cod); setForm(r.data)
  }
  function novo() { setSelecionado(''); setForm({ ...NOVO }); setMsg(null) }
  const set = <K extends keyof Combustivel>(k: K, v: Combustivel[K]) => setForm(f => f && { ...f, [k]: v })

  async function salvar() {
    if (!form) return
    setSalvando(true); setMsg(null)
    try {
      const corpo = { comcod: form.comcod, comest: form.comest, comdes: form.comdes, comapli: form.comapli, comdta: form.comdta || null }
      if (selecionado) await api.put(`/combustivel-cadastro/${encodeURIComponent(selecionado)}`, corpo)
      else await api.post('/combustivel-cadastro', corpo)
      const cod = selecionado || form.comcod.trim().toUpperCase()
      await carregarLista(busca); await selecionar(cod)
      setMsg({ texto: selecionado ? 'Alterações salvas.' : 'Combustível cadastrado.', ok: true })
    } catch (e: any) { setMsg({ texto: e?.response?.data?.error || 'Erro ao salvar.', ok: false }) }
    finally { setSalvando(false) }
  }

  async function excluir() {
    if (!selecionado || !window.confirm(`Excluir o combustível ${selecionado}?`)) return
    setSalvando(true); setMsg(null)
    try {
      await api.delete(`/combustivel-cadastro/${encodeURIComponent(selecionado)}`)
      setSelecionado(null); setForm(null); await carregarLista(busca)
    } catch (e: any) { setMsg({ texto: e?.response?.data?.error || 'Erro ao excluir.', ok: false }) }
    finally { setSalvando(false) }
  }

  const hoje = new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10)

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      <div className="card" style={{ width: 300, flexShrink: 0 }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.9rem', color: '#1a6ea8', paddingBottom: '0.6rem', borderBottom: '2px solid #eff6ff' }}>Combustíveis</h3>
        <div style={{ display: 'flex', gap: 8, marginBottom: '0.75rem', alignItems: 'center' }}>
          <div className="field" style={{ flex: 1 }}>
            <input type="text" placeholder="Buscar pelo código..." value={busca} onChange={e => setBusca(e.target.value)} />
          </div>
          <button className="btn btn-primary btn-sm" onClick={novo}>+ Novo</button>
        </div>
        {carregando && <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Carregando...</p>}
        {!carregando && lista.length === 0 && <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Nenhum combustível encontrado.</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 560, overflowY: 'auto' }}>
          {lista.map(c => {
            const ativo = selecionado === c.comcod
            return (
              <button key={c.comcod} onClick={() => selecionar(c.comcod)} style={{
                textAlign: 'left', border: '1px solid #e5e7eb', borderLeft: '4px solid #1a6ea8', borderRadius: 6, padding: '8px 10px', cursor: 'pointer',
                background: ativo ? '#eff6ff' : '#f8fafc', borderColor: ativo ? '#1a6ea8' : '#e5e7eb',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontWeight: 700, fontSize: '0.85rem' }}>{c.comcod}</span>
                  {c.comdta && <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#fff', background: '#dc2626', borderRadius: 4, padding: '0.15rem 0.45rem' }}>Desativado</span>}
                </div>
                <div style={{ fontSize: '0.76rem', color: '#374151', marginTop: 3 }}>{c.item_des || (c.comest ? `Item ${c.comest}` : 'sem item de estoque')}</div>
              </button>
            )
          })}
        </div>
      </div>

      <div className="card" style={{ flex: 1, minWidth: 0 }}>
        {selecionado === null && <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Selecione um combustível na lista ao lado, ou clique em "+ Novo".</p>}
        {selecionado !== null && form && (
          <>
            <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8', marginBottom: '0.6rem', paddingBottom: '0.5rem', borderBottom: '2px solid #eff6ff' }}>
              {selecionado ? `Combustível ${selecionado}` : 'Novo Combustível'}
              {form.comdmo && <span style={{ marginLeft: 12, fontSize: '0.72rem', fontWeight: 500, color: '#94a3b8' }}>última alteração em {form.comdmo.split('-').reverse().join('/')}</span>}
            </h3>
            <div style={{
              background: '#f7faff', border: '1px solid #eef0f4', borderLeft: '4px solid #1a6ea8', borderRadius: '0.5rem', padding: '0.55rem 0.85rem',
              marginBottom: '0.55rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem 0.9rem', alignItems: 'flex-end',
            }}>
              <Campo label="Combustível" width={110}>
                <input type="text" maxLength={9} value={form.comcod} disabled={!!selecionado} onChange={e => set('comcod', e.target.value.toUpperCase())} style={{ width: '100%' }} />
              </Campo>
              <Campo label="Código Estoque" width={420}>
                <ItemSelect codValue={form.comest ? String(form.comest) : ''} descValue={form.item_des || ''} unValue=""
                  onChange={(cod, des) => setForm(f => f && { ...f, comest: Number(cod) || 0, item_des: des || null })} />
              </Campo>
              <Campo label="Código Despesa" width={260}>
                <select value={form.comdes || ''} onChange={e => set('comdes', Number(e.target.value) || 0)} style={{ width: '100%' }}>
                  <option value="">—</option>
                  {tiposDespesa.map(t => <option key={t.cod} value={t.cod}>{t.cod} — {t.des}</option>)}
                </select>
              </Campo>
            </div>
            <div style={{
              background: '#f7faff', border: '1px solid #eef0f4', borderLeft: '4px solid #1a6ea8', borderRadius: '0.5rem', padding: '0.55rem 0.85rem',
              marginBottom: '0.55rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem 0.9rem', alignItems: 'flex-end',
            }}>
              <Campo label="Conta Aplicação" width={360}>
                <LookupSelect endpoint="/erp/aplicacoes" codKey="apl_cod" descKey="apl_des" tagKey="apl_cod"
                  codValue={form.comapli} descValue={form.apl_des || form.comapli}
                  onSelect={(cod, des) => setForm(f => f && { ...f, comapli: cod, apl_des: des })} placeholder="Nenhuma" />
              </Campo>
              {form.comapli && <button className="btn btn-sm" onClick={() => setForm(f => f && { ...f, comapli: '', apl_des: null })}>Limpar</button>}
              <Campo label="Desativado em" width={160}>
                <input type="date" max={hoje} value={form.comdta ?? ''} onChange={e => set('comdta', e.target.value || null)} style={{ width: '100%' }} />
              </Campo>
              <span style={{ fontSize: '0.78rem', color: '#6b7280' }}>(em branco = ativo)</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : selecionado ? 'Salvar alterações' : 'Cadastrar'}</button>
              {selecionado && <button className="btn" onClick={excluir} disabled={salvando} style={{ color: '#b91c1c' }}>Excluir</button>}
              {msg && (
                <span style={{ fontSize: '0.8rem', fontWeight: 600, padding: '0.35rem 0.8rem', borderRadius: 6, background: msg.ok ? '#d1fae5' : '#fee2e2', color: msg.ok ? '#065f46' : '#991b1b' }}>{msg.texto}</span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
